import { FormControl } from "@angular/forms";
import { map, Observable, startWith } from "rxjs";

/** 
 * Maps validation errors from a FormControl to corresponding error messages.
 * 
 * @param control - The FormControl whose errors will be checked.
 * @param errorMessagesObject - An object containing error messages, where the keys must match the error keys in the FormControl.
 * 
 * IMPORTANT: For proper mapping, ensure that the keys in the errorMessages object correspond exactly to the keys of the errors in the FormControl.
 * 
 * This function retrieves the error from the FormControl and returns the corresponding message from the errorMessages object.
 */
export function getErrorMsgFromControl(control: FormControl, errorMessagesObject: { [key: string]: string }): Observable<string | null> {

    return control.valueChanges
        .pipe(
            startWith(''), // Required for the initial emit to handle cases where the user clicks the input field and then clicks away, ensuring that the 'required' error is shown immediately.
            map(_ => {      
                if (control.errors) {
                    const errors = Object.keys(control.errors);
                    const error = errors
                        .map(err => errorMessagesObject?.[err])
                        .filter(err => err !== undefined)
                        .at(0);

                    return error || null;
                }

                return null;
            }));
}